<template>
    <div>
        <ErrorAlert :message="message" :error="error" />
        <div class="card card-body border-0">
            <h6 class="font-weight-bold mb-4">Submit for Approval</h6>
            <h6 class="font-weight-bold text-2">Accept our Terms and Conditions to complete Biller Registration</h6>

            <div class="row">
                <div class="col-12">
                    <div
                        class="terms-and-conditions"
                    >
                        <BillerTerms />
                    </div>
                    <div class="mt-3">
                        <label>
                            <input
                                type="checkbox"
                                v-model="agreeToTerms"
                            />
                            I have read and agree to the Terms and Conditions.
                        </label>
                    </div>
                </div>
            </div>
        </div>

        <div class="d-flex justify-content-center my-4">
            <button
                class="btn btn-primary mr-2"
                :class="{ 'btn-loading': loading }"
                @click="submitForApproval"
                :disabled="!agreeToTerms"
            >
                Submit For Approval
            </button>
            <button
                class="btn btn-danger"
                @click="declineTerms"
            >
                Decline Terms
            </button>
        </div>
    </div>
</template>

<script>
import ErrorAlert from "../../../components/ErrorAlert.vue";
import BillerTerms from "./BillerTerms.vue";

export default {
    name: "SubmitForApproval",
    components: {
        ErrorAlert,
        BillerTerms
    },
    props:['stage','message'],
    data() {
        return {
            agreeToTerms: false,
            message: "",
            error: false,
            loading: false,
        };
    },
    methods: {
        async submitForApproval() {
            if (!this.agreeToTerms) {
                this.error = true;
                this.message = "You must agree to the terms and conditions to proceed.";
                return;
            }

            this.loading = true;
            this.error = false;
            this.message = "";

            axios.post(`/business/biller-onboarding/approval`, {})
                .then((response) => {
                    this.message = response.data.message;
                    this.loading = false;
                    window.location = `${window.location.origin}/business/payments`;
                })
                .catch((error) => {
                    this.error = true;
                    this.message = error.response?.data?.message || "Failed to submit for approval.";
                    this.loading = false;
                });
        },
        declineTerms() {
            this.message = "You have declined the terms and conditions. Registration cannot proceed.";
            this.error = true;
        },
    },
};
</script>

<style scoped>
.terms-and-conditions {
    max-height: 500px;
    overflow-y: scroll;
    border: 1px solid #ddd;
    padding: 10px;
}
</style>
